// extracted by mini-css-extract-plugin
export default {"contractResponsibles":"ContractResponsibles_contractResponsibles__wq8RX"};